/* eslint-disable react/prop-types */

import React  from 'react';
//import { toJS } from 'mobx';

import { Spinner } from 'react-bootstrap';

import { observer } from 'mobx-react';

import { useAuth } from '../../hooks/auth';

import { DataTable } from '../table/DataTable';
import rowTypes from '../table/rowTypes';

import { SubmitButton } from '../general/SubmitButton';
import { StringSelect } from '../general/StringSelect';
import { EnumSelect } from '../general/EnumSelect';
import { DateOnly } from '../general/ShortDate';
import { MappedLabel } from '../general/MappedLabel';

import { asStringCompare } from '../utils/compare';
import { localDateFilter, numericFilter } from '../utils/filter';

import { TaskStateSelect } from './TaskStateSelect';

import { ReactComponent as DeleteSVG } from '../../assets/delete.svg';

const stateOpts = ['requested', 'completed'];

const tableSchema = {
    type: 'object',
    properties: {
        state: { type: 'string', title: 'State' },
        requiredBy: { type: 'string', title: 'Required By' },
        siteId: { type: 'string', title: 'Site' },
        who: { type: 'string', title: 'Who' },
        task: { type: 'string', title: 'Task' },
        quantity: { type: 'integer', title: 'Quantity' },
        unit: { type: 'string', title: 'Unit' },
    }
};

const tableFilters = ['task', 'siteId', 'who', 'state', 'requiredBy'];

const TaskDataGrid = observer(({ api, onError, taskStore, style = {} }) => {
    const authStore = useAuth();
    const [siteMap, setSiteMap] = React.useState(null);
    const [whoOpts] = React.useMemo(
        () => {
            const whoSet = new Set();

            for (const e of taskStore.tasks) {
                whoSet.add(e.who);
            }

            return [[...whoSet]];
        },
        [taskStore.tasks]
    );

    React.useEffect(
        () => {
            api.axios.get('/tasks/sites')
            .then(res => {
                const siteMap = new Map(res.data.sites.map(e => [e.id, e.name]));
                setSiteMap(siteMap);
            })
            .catch(err => {
                onError(err);
            });

            return () => {};
        }, []
    );

    const insertDelete = (id, rowType, rowData) => {
        switch (rowType) {
            case rowTypes.filter:
                // Fall through intentional

            case rowTypes.header:
                return [' '];

            case rowTypes.body:
                return [
                    <SubmitButton size='sm' variant='outline-danger'
                        key={`delete_${rowData.id}`}
                        id={rowData.id}
                        onSubmit = {() => taskStore.deleteTask([rowData.id]).catch(err => onError(err.toString()))}
                        body={<p>Are you sure you want to delete the entry?</p>}
                        style={{ width: '41px' }}
                    >
                        <DeleteSVG  style = {{height: '1.2rem' }}/>
                    </SubmitButton>
                ];

            default:
                return null;
        }
    };

    if (taskStore.loading || !siteMap) {
        return <div style={{ textAlign: 'center', gridColumn: '1/-1', marginTop: '2em' }}>
            <span>Loading...<Spinner animation='border' variant='info' size='sm' style={{ marginLeft: '2rem'}}/></span>
        </div>
    }

    return (
        <div style={{ width: '100%', ...style }}>
            <DataTable
                schema={tableSchema}
                filterFor={tableFilters}
                decorate={false}
                borders={false}
                noDataMessage='No Tasks for your sites'
                data={taskStore.tasks}
                uniqueIdField='id'
                headerRowHeight={40}
                insertCells = {
                    authStore.user.permissions.includes('delTask')
                    ? insertDelete
                    : undefined
                }
                customCells={{
                    state: {
                        component: <TaskStateSelect taskStore={taskStore} onError={onError} />,
                        filterComponent: <StringSelect options={stateOpts} isClearable={true} />,
                    },
                    who: {
                        filterComponent: <StringSelect options={whoOpts} isClearable={true} />,
                    },
                    requiredBy: {
                        component: <DateOnly />,
                        filterFn: localDateFilter,
                    },
                    siteId: {
                        component: <MappedLabel map={siteMap} />,
                        filterComponent: <EnumSelect optionsMap={siteMap} isClearable={true} />,
                        compareFn: asStringCompare,
                        filterFn: numericFilter,
                    },
                }}
            />
        </div>
    );
});

export {
    TaskDataGrid,
}
